import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';
import { AppConfig } from '../config/types';
import config, { loadConfig } from '../config/index';

// Typ dla contextProvider
interface ConfigProviderProps {
  children: ReactNode;
  initialClientId?: string;
}

// Context z typem
export const ConfigContext = createContext<{
  config: AppConfig;
  setClientId: (clientId: string) => void;
}>({
  config,
  setClientId: () => {},
});

// Provider z typami
export function ConfigProvider({
  children,
  initialClientId = 'default',
}: ConfigProviderProps) {
  const [clientId, setClientId] = useState<string>(initialClientId);
  const [appConfig, setAppConfig] = useState<AppConfig>(config);

  useEffect(() => {
    // Załaduj konfigurację dla wybranego klienta
    const newConfig = loadConfig(clientId);
    setAppConfig(newConfig);
  }, [clientId]);

  return (
    <ConfigContext.Provider
      value={{
        config: appConfig,
        setClientId,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}

// Hook do używania konfiguracji w komponentach
export function useConfig(): AppConfig {
  const { config } = useContext(ConfigContext);
  return config;
}

// Hook do zmiany klienta
export function useClientSwitcher(): (clientId: string) => void {
  const { setClientId } = useContext(ConfigContext);
  return setClientId;
}

// Hook do pobierania części konfiguracji
export function useConfigSection<K extends keyof AppConfig>(
  section: K,
): AppConfig[K] {
  const { config } = useContext(ConfigContext);
  return config[section];
}
